import {
	getUserInfo
} from "@/api/oauth/index"

const state = {
	menuList: [],
	userInfo: {},
	permissionList: [],
	userInfoLoaded: false, // 标记用户信息是否已加载
}

const mutations = {
	SET_MENULIST: (state, menuList) => {
		state.menuList = menuList
	},
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo
	},
	SET_PERMISSION_LIST: (state, permissionList) => {
		state.permissionList = permissionList
	},
	SET_USER_INFO_LOADED: (state, loaded) => {
		state.userInfoLoaded = loaded
	},
	// 清除用户信息
	CLEAR_USER_INFO: (state) => {
		state.menuList = []
		state.userInfo = {}
		state.permissionList = []
		state.userInfoLoaded = false
	}
}

const actions = {
  // 获取用户信息
  getCurrentUser({commit, state}) {
  	return new Promise((resolve, reject) => {
  		// 如果用户信息已经加载过，直接返回
  		if (state.userInfoLoaded) {
  			resolve()
  			return
  		}
  		
  		getUserInfo().then(response => {
  			const {
  				data
  			} = response
  			if (!data) reject('验证失败，请重新登录。')
  			let {
  				isWeakPwd,
  				menuList,
  				userInfo,
  				permissionList,
          authCodeList
  			} = data
  			if (!menuList.length) {
  				reject('您的权限不足，请联系管理员')
  				return false;
  			}
  			commit('SET_MENULIST', menuList)
  			commit('SET_USERINFO', userInfo)
  			commit('SET_PERMISSION_LIST', authCodeList)
  			commit('SET_USER_INFO_LOADED', true) // 标记用户信息已加载
        resolve()
  		}).catch(error => {
  			reject(error)
  		})
  	})
  },
  // 清除用户信息（用于登出）
  clearUserInfo({commit}) {
  	commit('CLEAR_USER_INFO')
  }
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}